// locale: checkEmail:VALIDATION_MESSAGES
export const EMAIL_VALIDATION_ERROR_CODE = {
  INVALID_EMAIL: 'INVALID_EMAIL',
  INVALID_EMAIL_DOMAIN: 'INVALID_EMAIL_DOMAIN',
  INVALID_PERSONAL_EMAIL: 'INVALID_PERSONAL_EMAIL',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  USER_NOT_MANAGER: 'USER_NOT_MANAGER',
  SAME_USER: 'SAME_USER',
  ORIGIN_MANAGER: 'ORIGIN_MANAGER',
  NEW_HIRE_INFORMATION: 'NEW_HIRE_INFORMATION',
};
